<template>
  <div class='ToLike' :style="{
    backgroundColor: Prefes.btn.corBackground,
    color: Prefes.btn.corFont,
    fontFamily: Prefes.btn.font,
    fontStyle: parseInt(Prefes.btn.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.btn.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.btn.textDecoration) ? 'underline' : '',
    fontSize: Prefes.btn.fontHeight + 'px'
  }">
    <heart-icon tam="22px" :color="Prefes.btn.corFont"/>
    Meus favoritos
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeartIcon from '../Icons/HeartIcon'
export default {
  name: 'ToLike',
  components: { HeartIcon },
  props: ['liked'],
  computed: {
    ...mapGetters(['Prefes'])
  }
}
</script>

<style scoped>
.ToLike {
  display: flex;
  justify-content: center;
  align-items: center;
  width: max-content;
  padding: 2%;
  border-radius: 5px;
  background-color: orange;
  cursor: pointer;
  white-space: nowrap
}
</style>
